import moment from "moment";

export interface Request {
  id_plazo: number;
  new: boolean;
  nexu_model_id: number;
  suma_asegurada: number;
  modelo: number;
  desc_marca?: string;
}

export interface QuoteInf {
  term: number;
  new_asset: boolean;
  model_id: number;
  price: number;
  year: number;
  product: string;
  brand?: string;
}

export interface Receipt {
  info_changed: boolean;
  product: string;
  fec_solicitud: string;
}

export class Insurance {
  public static checkReceiptValidity(receipt: Receipt, insurance_request: Request, insurance_quote_info: QuoteInf) {
    let validity = false;
    let issued_date = moment(receipt.fec_solicitud);
    let valid_thru = issued_date.add(30, "days");
    let in_dates = valid_thru > moment();

    if (insurance_request == undefined) {
      return { validity, valid_thru };
    }

    let different_info = this.getDifferentInfo(receipt, insurance_request, insurance_quote_info);

    validity = in_dates && !receipt.info_changed && different_info.length == 0;
    return { validity, valid_thru, different_info };
  }

  private static getDifferentInfo(
    receipt: Receipt,
    insurance_request: Request,
    insurance_quote_info: QuoteInf
  ): string[] {
    let different_info: string[] = [];

    if (insurance_request.id_plazo != (insurance_quote_info.term || insurance_request.id_plazo)) {
      different_info.push("term");
    }

    // Normalize boolean values: undefined/null/false → false, only true → true
    const requestNew = !!insurance_request.new;
    const quoteNewAsset = !!insurance_quote_info.new_asset;
    if (requestNew !== quoteNewAsset) {
      different_info.push("new_asset");
    }

    // if (insurance_request.desc_marca != insurance_quote_info?.brand?.toUpperCase()) {
    //   different_info.push("brand");
    //   different_info.push("vehicle");
    // }

    if (insurance_request.nexu_model_id != insurance_quote_info.model_id) {
      different_info.push("model");
      different_info.push("vehicle");
    }

    if (insurance_request.new && insurance_request.suma_asegurada != insurance_quote_info.price) {
      different_info.push("price");
      different_info.push("vehicle");
    }

    if (insurance_request.modelo != insurance_quote_info.year) {
      different_info.push("year");
      different_info.push("vehicle");
    }

    if (receipt.product != (insurance_quote_info.product || receipt.product)) {
      different_info.push("product");
    }

    return different_info;
  }
}
